import { render, staticRenderFns } from "./followUpDialog.vue?vue&type=template&id=359ec877&scoped=true"
import script from "./followUpDialog.vue?vue&type=script&lang=js"
export * from "./followUpDialog.vue?vue&type=script&lang=js"
import style0 from "./followUpDialog.vue?vue&type=style&index=0&id=359ec877&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359ec877",
  null
  
)

export default component.exports